import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild
  } from '@angular/core';
import { RoutingPath } from './../../../../configs/routing-path';

@Component({
  selector: 'app-aside',
  templateUrl: './aside.component.html',
  styleUrls: ['./aside.component.scss']
})
export class AsideComponent implements OnInit, OnChanges {

  public dropActive: boolean;
  @Input() clickShadow: boolean;
  @Output() overlayActive: EventEmitter<boolean>;
  @ViewChild('dropAvatar', {static: false}) dropAvatar: ElementRef;
  @ViewChild('elmAvatar', {static: false}) elmAvatar: ElementRef;
  @ViewChild('menuAside', {static: false}) menuAside: ElementRef;
  private indexMenu: boolean = false;


  private NOTREMOVEVIEWMENUELEMENTIDS: Array<string> = [
    "Menu Lateral _PTPC-Descargas-Extractos de productos",
    "Menu Lateral _PTPC-Descargas-Certificado de afiliación",
    "Menu Lateral _PTPC-Descargas-Certificados paz y salvo",
    "Menu Lateral _PTPC-Descargas-Estado cuenta subsidio familiar",
    "Menu Lateral _PTPC-Solicitud-Subsidio Familiar",
    "Menu Lateral _PTPC-Solicitud-Subsidio de vivienda o arrendamiento",
    "Menu Lateral _PTPC-Solicitud-Subsidio por fallecimiento del baneficiario",
    "Menu Lateral _PTPC-Solicitud-credito-clic"
  ];

  screenWidth: number;
  ifScreenWidth = false;

  constructor(private _renderer: Renderer2) {
    this.overlayActive = new EventEmitter();
  }

  routes = [

    {
      path: RoutingPath.appRouting.components.dashboard.path + '/' + RoutingPath.appRouting.components.dashboard.pages.affiliation.path,
      icon: 'account_circle',
      name: 'Afiliación',
      description: 'Afiliaciones'
    },
    {
      path: '',
      icon: 'cloud_download',
      name: 'Descarga',
      description: 'Descarga de certificados',
      childrens: [
        {
          path: RoutingPath.appRouting.components.certificates.path + '/' + RoutingPath.appRouting.components.certificates.pages.company_affiliation_certificate.path,
          icon: 'keyboard_arrow_right',
          name: 'Certificado de afiliación empresa',
          description: 'Certificado de afiliación empresa'
        },
        {
          path: RoutingPath.appRouting.components.certificates.path + '/' + RoutingPath.appRouting.components.certificates.pages.consult_worker.path,
          param: RoutingPath.appRouting.components.certificates.pages.worker_affiliation_certificate.id,
          icon: 'keyboard_arrow_right',
          name: 'Certificado de afiliación trabajador',
          description: 'Certificado de afiliación trabajador'
        }/*,
        {
          path: RoutingPath.appRouting.components.certificates.path + '/' + RoutingPath.appRouting.components.certificates.pages.consult_worker.path,
          param: RoutingPath.appRouting.components.certificates.pages.search_monetary_fee.id,
          icon: 'keyboard_arrow_right',
          name: 'Certificado cuota monetaria trabajador',
          description: 'Certificado cuota monetaria trabajador'
        }*/
      ]
    }
  ];

  ngOnInit() {
    this.screenWidth = window.innerWidth;
    window.onresize = () => {
      this.screenWidth = window.innerWidth;
    };

    this.calculateIfScreenWidth();

    // Scroll footer
    addEventListener('scroll', () => {
      if (window.innerWidth < 768) {
        if ((window.innerHeight + window.pageYOffset) >= (document.body.offsetHeight - 100)) {
          document.querySelector('.l-aside').classList.remove('is-up');
          document.querySelector('.l-aside').classList.add('is-down');
          if (this.dropActive) {
            this.clickPaga();
          }
        } else {
          document.querySelector('.l-aside').classList.remove('is-down');
          document.querySelector('.l-aside').classList.add('is-up');
        }
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      this.dropActive = false;
      this.overlayActive.emit(this.dropActive);
    }
  }

  dropDown() {
    this._renderer.listen('window', 'click', (event) => {
      if (this.elmAvatar!=undefined && event.target!=null && event.target !== this.elmAvatar.nativeElement) {
        this._renderer.removeClass(this.dropAvatar.nativeElement, 'c-dropdown--active');
        this.dropActive = false;
        this.overlayActive.emit(this.dropActive);
      }
    });
  }

  clickPaga() {
    this.showOrHiddenToggle();
    let expand = (this.dropActive) ? 'true' : 'false';
    this._renderer.removeAttribute(this.menuAside.nativeElement,'aria-expanded');
    this._renderer.setAttribute(this.menuAside.nativeElement,'aria-expanded',expand);

  }

  hiddeToggle(event: any) {

    if (this.indexMenu) {

      this.dropActive = false;
      this.overlayActive.emit(false);
      this._renderer.removeAttribute(this.menuAside.nativeElement,'aria-expanded');
      this._renderer.setAttribute(this.menuAside.nativeElement,'aria-expanded',"false");
    }

  }
  onfocusLastItem(index: any){
    this.indexMenu = index;
  }

  showOrHiddenToggle(){
    this.dropActive = !this.dropActive;
    this.overlayActive.emit(this.dropActive);
  }


  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.screenWidth = event.target.innerWidth;
    this.calculateIfScreenWidth();
  }

  calculateIfScreenWidth() {
    this.screenWidth < 768 ? this.ifScreenWidth = true : this.ifScreenWidth = false;
  }

  @HostListener('document:keydown.escape', ['$event'])
  onKeydown(event: KeyboardEvent) {

    if (event.code=='Escape'){
      this.dropActive = false;
      this.overlayActive.emit(false);
    }
  }


}


